import { Jodit } from "jodit";

let isPreparePasteRegistered = false;

function preparePaste(jodit) {
    jodit.e.on(
        'paste',
        e => {
            jodit.e.stopPropagation('paste');
            jodit.s.insertHTML(
                Jodit.modules.Helpers.getDataTransfer(e)
                    .getData(Jodit.constants.TEXT_HTML)
                    .replace(/a/g, 'b')
            );
            return false;
        },
        { top: true }
    );
}

export const ensurePreparePastePlugin = () => {
    if (isPreparePasteRegistered) {
        return;
    }

    Jodit.plugins.add('preparePaste', preparePaste);

    const extraPlugins = Array.isArray(Jodit.defaultOptions.extraPlugins)
        ? Jodit.defaultOptions.extraPlugins
        : typeof Jodit.defaultOptions.extraPlugins === 'string'
            ? Jodit.defaultOptions.extraPlugins.split(',')
            : [];

    if (!extraPlugins.includes('preparePaste')) {
        Jodit.defaultOptions.extraPlugins = [...extraPlugins, 'preparePaste'];
    }

    isPreparePasteRegistered = true;
};

ensurePreparePastePlugin();
